/** Well-known folder names — use these instead of bare string literals. */
// DRAFTS is the backend name for the folder the UI labels MAIN_TEMPLATES; see utils/folderNames.ts.
export const FOLDER_NAMES = {
  DRAFTS: "Drafts",
  MAIN_TEMPLATES: "Main Templates",
  DEMO_TEMPLATES: "DemoTemplates",
} as const;

/** Common template priority codes and their user-facing labels. */
export const TEMPLATE_PRIORITIES = {
  TRANSACTIONAL: { shortName: "STD", displayName: "Transactional" },
  RESTRICTIVE_PRIORITY: {
    shortName: "RP",
    displayName: "Restrictive Priority",
  },
} as const;

/** S3 upload constants — platform ID for metadata in presigned URLs. */
export const S3_CONSTANTS = {
  PLATFORM_ID: "AIDE_0082245",
} as const;
